export default __webpack_public_path__ + "static/media/mywishes-robot.bf77734b.png";